(function () {
    var config = window.CBDMD_DELTA9_GEO;
    if (!config || !config.enabled) return;
  
    var DEFAULT_GEO_URL = 'https://ipapi.co/json/';
    var geoApiUrl = (config.geoApiUrl && String(config.geoApiUrl).trim()) || DEFAULT_GEO_URL;
    var cacheMin = parseInt(config.geoCacheMinutes, 10);
    if (isNaN(cacheMin) || cacheMin < 0) {
      cacheMin = 1440;
    }
    var STORAGE_TTL_MS = cacheMin * 60 * 1000;
    var useGeoCache = STORAGE_TTL_MS > 0;
    var STORAGE_KEY = 'cbdmd_delta9_geo_v1';
  
    var modal = document.getElementById('Delta9StateBlocker');
    if (!modal) return;
  
    var rawStates = config.blockedStates;
    var blockedStates = Array.isArray(rawStates)
      ? rawStates
      : (typeof rawStates === 'string' ? rawStates.split(',') : []);
    blockedStates = blockedStates
      .map(function (s) { return String(s).trim(); })
      .filter(Boolean);
    var blockedSet = new Set(blockedStates.map(function (s) { return s.toUpperCase(); }));
  
    function getProductForms() {
      return Array.prototype.slice.call(
        document.querySelectorAll(
          'form[action*="/cart/add"], product-form form, .product-form form, form[data-type="add-to-cart-form"]'
        )
      );
    }
  
    function getAddToCartButtons() {
      return Array.prototype.slice.call(
        document.querySelectorAll(
          'button[name="add"], .product-form__submit, [data-add-to-cart], button[type="submit"][name="add"]'
        )
      );
    }
  
    function showModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('delta9-state-blocker-open');
      document.body.classList.add('delta9-state-blocker-open');
    }
  
    function hideModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('delta9-state-blocker-open');
      document.body.classList.remove('delta9-state-blocker-open');
    }
  
    function disableAddToCart(message) {
      var buttons = getAddToCartButtons();
  
      buttons.forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('delta9-atc-disabled');
  
        if (!btn.dataset.originalText) {
          btn.dataset.originalText = btn.textContent.trim();
        }
  
        btn.textContent = 'Unavailable in Your State';
      });
  
      var forms = getProductForms();
  
      forms.forEach(function (form) {
        if (form.dataset.delta9BlockBound === 'true') return;
        form.dataset.delta9BlockBound = 'true';
  
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();
          showModal();
          return false;
        }, true);
      });
  
      insertInlineNotice(message);
    }
  
    function insertInlineNotice(message) {
      var forms = getProductForms();
      if (!forms.length) return;
  
      forms.forEach(function (form) {
        if (form.parentNode && form.parentNode.querySelector('.delta9-inline-notice')) return;
  
        var note = document.createElement('div');
        note.className = 'delta9-inline-notice';
        note.textContent = message;
  
        form.parentNode.insertBefore(note, form);
      });
    }
  
    function isBlockedState(regionCode, countryCode) {
      if (String(countryCode || '').toUpperCase() !== 'US') return false;
      return blockedSet.has(String(regionCode || '').toUpperCase());
    }
  
    function getCachedGeo() {
      if (!useGeoCache) {
        return null;
      }
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
  
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.ts || !parsed.data) return null;
  
        if (parsed.apiUrl && parsed.apiUrl !== geoApiUrl) {
          return null;
        }
  
        if ((Date.now() - parsed.ts) > STORAGE_TTL_MS) {
          localStorage.removeItem(STORAGE_KEY);
          return null;
        }
  
        return parsed.data;
      } catch (e) {
        return null;
      }
    }
  
    function setCachedGeo(data) {
      if (!useGeoCache) {
        return;
      }
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          ts: Date.now(),
          data: data,
          apiUrl: geoApiUrl
        }));
      } catch (e) {}
    }
  
    async function fetchGeo() {
      var cached = getCachedGeo();
      if (cached) return cached;
  
      var response = await fetch(geoApiUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error('Geo lookup failed with status ' + response.status);
      }
  
      var data = await response.json();
      setCachedGeo(data);
      return data;
    }
  
    function bindModalClose() {
      modal.addEventListener('click', function (e) {
        if (e.target.matches('[data-d9-close]')) {
          hideModal();
        }
      });
  
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) {
          hideModal();
        }
      });
    }
  
    async function init() {
      bindModalClose();
  
      try {
        var geo = await fetchGeo();
        var countryCode = geo && (geo.country_code || geo.country);
        var regionCode = geo && (geo.region_code || geo.region);
  
        if (isBlockedState(regionCode, countryCode)) {
          showModal();
          if (config.isDelta9Product) {
            disableAddToCart(config.message);
          }
        }
      } catch (err) {
        // Fail open:
        // If geo fails, we do not block the user here.
        // Checkout/shipping rules should remain the final enforcement layer.
        console.warn('[Delta9StateBlocker]', err);
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
